import { Link, Outlet } from 'react-router-dom';
import logoNegativo from '../../assets/logos/quadroam-negativo.svg';
import { useSession } from '../../lib/useSession';
import { BRAND } from '../../brand';

/** App del vendedor en terreno: mobile-first, 360 px, botones de 48 px (R5.4). */
export function FieldLayout() {
  const { activeOrg, user } = useSession();
  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col bg-white">
      <header className="flex items-center justify-between bg-asphalt px-4 py-3 text-chalk">
        <Link to="/terreno" aria-label="Inicio de terreno">
          <img src={logoNegativo} alt={BRAND} className="h-6 w-auto" />
        </Link>
        <span className="text-xs text-gray-300">
          {activeOrg?.orgName ?? ''} {user?.email ? `· ${user.email}` : ''}
        </span>
      </header>
      <main className="flex-1 p-4">
        <Outlet />
      </main>
    </div>
  );
}
